import React, { ReactNode } from 'react';
import { ScrollableElementContainer, ScrollableElementContainerProps } from '../ScrollableElementContainer';
type Props = ScrollableElementContainerProps & {
  // Children should either be ArticleSectionContent
  // or [ArticleSectionTitle, ArticleSectionContent]
  children: ReactNode;
};
export const ArticleSection = ({
  children,
  ...rest
}: Props) => <ScrollableElementContainer width={1} {...rest} data-sentry-element="ScrollableElementContainer" data-sentry-component="ArticleSection" data-sentry-source-file="index.tsx">
    {children}
  </ScrollableElementContainer>;
export type ArticleSectionProps = Props;